import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Unpopulated } from 'data/Populated'
import { createSelector } from 'reselect'
import { getShow } from 'redux/slices/liveShow'
import { Pass } from 'data/Pass'
import { RootState } from 'redux/store'

interface PaywallState {
    userPasses: Pass[]
    showPassList: Pass[]
    createPass: {
        loading: boolean
        error: string | null
    }
}

export const initialState: PaywallState = {
    userPasses: [],
    showPassList: [],
    createPass: {
        loading: false,
        error: null,
    },
}

const passesSlice = createSlice({
    name: 'passes',
    initialState,
    reducers: {
        resetState: _ => initialState,
        showPassListReceived: (state, { payload }: PayloadAction<Pass[]>) => ({ ...state, showPassList: payload }),
        userPassesReceived: (state, { payload }: PayloadAction<Pass[]>) => ({ ...state, userPasses: payload }),
        purchasePassReceieved: (state, { payload }: PayloadAction<Pass>) => {
            state.showPassList.push(payload)
        },
    },

    extraReducers: {
        'passes/createPass/pending': state => {
            state.createPass.loading = true
            state.createPass.error = null
        },
        'passes/createPass/rejected': (state, { error }: { error: string | { message: string } }) => {
            state.createPass.loading = false
            state.createPass.error = (error as { message: string }).message || (error as string)
        },
    },
})

const { actions, reducer } = passesSlice
export default reducer

export const getPassesState = (store: RootState) => store.passes
export const getShowPassList = createSelector(
    getPassesState,
    passes => passes.showPassList as Unpopulated<Pass, 'show'>[],
)
export const getUserPasses = createSelector(getPassesState, passes => passes.userPasses)
export const userHasPurchasedTicket = createSelector(
    store => getShow(store),
    getShowPassList,
    (show, passes) => passes.some(pass => pass.show === show?._id),
)

export const getCreatePassState = createSelector(getPassesState, state => state.createPass)
export const { resetState, showPassListReceived, purchasePassReceieved, userPassesReceived } = actions
